import {EnvEventPostDataTransferObjectDescription} from "../../../data/data-transfer-object-description/env/EnvEventPostDataTransferObjectDescription"
import {EnvEventPostState} from "../../../data/data-transfer-object-state/env/EnvEventPostState"
import {EnvEventPostDataTransferObject} from "../../../data/data-transfer-object/env/EnvEventPostDataTransferObject"
import {PostBigIntField, PostBitMaskField, PostBooleanField, PostDateField, PostEnumField, PostFieldWrapper, PostInputField, PostNumberField, PostTextareaField} from "../../PostField"
import {RouterProps} from "../../RouterProps"
import {JSX} from "react"

type PostFieldProps = RouterProps & {
    state: EnvEventPostState
}

export const EnvEventPostField: Record<Capitalize<keyof EnvEventPostDataTransferObject>, (props: PostFieldProps) => JSX.Element> = {
    Title(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={EnvEventPostDataTransferObjectDescription.title}>
                <PostTextareaField
                    {...props}
                    value={props.state.title.value}
                    setter={props.state.title.setter}
                    maxLength={400} />
            </PostFieldWrapper>
        )
    },
    Url(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={EnvEventPostDataTransferObjectDescription.url}>
                <PostTextareaField
                    {...props}
                    value={props.state.url.value}
                    setter={props.state.url.setter}
                    maxLength={4000} />
            </PostFieldWrapper>
        )
    },
}

export function EnvEventPostFields(props: PostFieldProps) {
    return <>
        <EnvEventPostField.Title
            {...props}
            state={props.state} />
        <EnvEventPostField.Url
            {...props}
            state={props.state} />
    </>
}
